import React, { useMemo, useState } from 'react';
import DatePicker from 'react-datepicker2';

import Icon from '@mdi/react';
import { mdiAccount, mdiEyeOff, mdiEye, mdiCloudUploadOutline } from '@mdi/js';

import './CInputPrime.sass';
import AUX from '../../../hoc/AU-X/AU-X';
// import './CInputPassword.sass';

const CInput = (props) => {
  const [visiblity, setVisiblity] = useState(true);
  const { validBoxShadow, config, direction, changed, value, blured } = props;

  const label = useMemo(() => {
    return (
      <span
        style={{
          color: validBoxShadow && 'rgba(222, 82, 70, 0.7)',
          right: direction && '5px',
          left: !direction && '5px',
          direction: direction,
          transformOrigin: direction === 'rtl' ? 'top right' : '0 0',
        }}
        className='label'
      >
        {config.placeholder}
      </span>
    );
  }, [validBoxShadow, direction, config]);

  if (config.type === 'file') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {!validBoxShadow ? (
          <p style={{ marginRight: '10px', fontSize: '15px' }}>{value.name}</p>
        ) : (
          <p style={{ marginRight: '8px', fontSize: '13px' }}>فایلی انتخاب نشده</p>
        )}
        <div className='fileInputKML'>
          <input
            type='file'
            id={config.placeholder}
            name={config.placeholder}
            onChange={changed}
            accept={`.${config.accept}`}
          />
          <label
            // style={{ border: !validBoxShadow ? '2px solid #a0c7ff' : '2px solid #bbb' }}
            style={{ border: !validBoxShadow ? '2px solid #0077FF' : '2px solid #bbb' }}
            htmlFor={config.placeholder}
          >
            انتخاب
            <Icon
              style={{ color: !validBoxShadow ? '#0077FF' : '#bbb' }}
              title='upload file'
              path={mdiCloudUploadOutline}
              size={1}
            />
          </label>
        </div>

        <br />

        <h3 style={{ direction: 'rtl', fontWeight: '100' }}>آپلود فایل به صورت {config.accept}</h3>
      </div>
    );
  }

  const renderInput = () => {
    switch (config.type) {
      case 'select':
        return (
          <select style={{ direction: direction }} value={value} onChange={changed}>
            <option>{'-'}</option>

            {config.options.map((option) => (
              <option key={option.value}>{option.value}</option>
            ))}
          </select>
        );

      case 'text':
        return (
          <AUX>
            {config.placeholder === 'نام کاربری' && (
              <Icon className='icons' path={mdiAccount} title='User Profile' size={1.1} />
            )}

            <input
              type={config.type}
              placeholder='&nbsp;'
              value={value}
              onChange={changed}
              onBlur={blured}
              style={{
                boxShadow: validBoxShadow && 'inset 0 -2px 0 rgba(222, 82, 70, 0.7)',
                direction: direction,
              }}
            />
          </AUX>
        );

      case 'calendar':
        return (
          <DatePicker
            showTodayButton={false}
            isGregorian={false}
            timePicker={false}
            persianDigits={false}
            placeholder='1399/9/09'
            value={value}
            onChange={changed}
          />
        );

      // case "textArea":
      //   return (
      //     <input
      //       type={config.type}
      //       placeholder="&nbsp;"
      //       value={value}
      //       onChange={changed}
      //       onBlur={blured}
      //       style={{
      //         boxShadow: validBoxShadow && 'inset 0 -2px 0 rgba(222, 82, 70, 0.7)',
      //         direction: direction,
      //         height: '85px',
      //         paddingBottom: '7px',
      //         overflow: 'visible'
      //       }}
      //     />
      //   );

      case 'password':
        return (
          <AUX>
            {config.type === 'password' && (
              <Icon
                style={{ cursor: 'pointer' }}
                className='icons'
                onClick={() => {
                  setVisiblity((last) => {
                    return !last;
                  });
                }}
                path={visiblity ? mdiEyeOff : mdiEye}
                title='User Password'
                size={1.1}
              />
            )}

            <input
              type={visiblity ? 'password' : 'text'}
              placeholder='&nbsp;'
              value={value}
              onChange={changed}
              onBlur={blured}
              style={{
                fontSize: visiblity && '20px',
                boxShadow: validBoxShadow && 'inset 0 -2px 0 rgba(222, 82, 70, 0.7)',
                direction: direction,
              }}
            />
          </AUX>
        );

      // case "custom":
      //   return props.custom;

      default:
        throw new Error('Should not be reached! -> CInput');
    }
  };

  return (
    <label className='inp'>
      {renderInput()}
      {label}

      <span className='focus-bg'></span>
    </label>
  );
};

export default CInput;
